import { render, staticRenderFns } from "./DraggableContent.vue?vue&type=template&id=0e7c73ec&scoped=true"
import script from "./DraggableContent.vue?vue&type=script&lang=js"
export * from "./DraggableContent.vue?vue&type=script&lang=js"
import style0 from "./DraggableContent.vue?vue&type=style&index=0&id=0e7c73ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7c73ec",
  null
  
)

export default component.exports